import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Message } from './model/Message';
import { BotService } from 'src/app/services/bot/bot.service';

@Component({
  selector: 'app-bot',
 imports: [CommonModule, FormsModule],
  templateUrl: './bot.component.html',
  styleUrl: './bot.component.scss'
})
export class BotComponent implements OnInit {

ngOnInit(): void {
  }

isOpen = signal<boolean>(false);
  userInput = signal<string>('');
  messages = signal<Message[]>([
    { text: '¡Hola! ¿En qué puedo ayudarte hoy?', isBot: true, timestamp: new Date() }
  ]);
  isLoading = signal<boolean>(false);

  constructor(private botService: BotService) {}

  toggleChat() {
    this.isOpen.update(v => !v);
  }

  send() {
    const text = this.userInput().trim();
    if (!text || this.isLoading()) return;

    // Agregar mensaje del usuario
    this.messages.update(prev => [...prev, { text, isBot: false, timestamp: new Date() }]);
    this.userInput.set('');
    this.isLoading.set(true);

    // Llamada al servicio Node.js
    this.botService.sendMessage(text).subscribe({
      next: (res) => {
        this.messages.update(prev => [...prev, { text: res.response, isBot: true, timestamp: new Date() }]);
        this.isLoading.set(false);
      },
      error: () => {
        this.messages.update(prev => [...prev, { text: 'Lo siento, hubo un error de conexión.', isBot: true, timestamp: new Date() }]);
        this.isLoading.set(false);
      }
    });
  }
}
